import {EditGuesser, ListGuesser, ShowGuesser} from "react-admin";

const PageCategoryResourceProps = {
    name: "page_category",
    list: ListGuesser,
    edit: EditGuesser,
    show: ShowGuesser,
};

export default PageCategoryResourceProps;
